// extracted by mini-css-extract-plugin
export default {"root":"MenuItemFooter_root__zjVkM","buttonFooterContainer":"MenuItemFooter_buttonFooterContainer__WpKc2","button":"MenuItemFooter_button__PQEbG"};